import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { Sparkles } from 'lucide-react';
import CalcSectionHeader from './CalcSectionHeader';

const PlanInformation = ({
 showPlanInfo,
 setShowPlanInfo,
 formData,
 setFormData,
 user,
 aiEstimatedFields,
 openAIDialog
}) => {
 return (
 <Card className="border border-border rounded-2xl overflow-hidden">
 <CalcSectionHeader
 icon={Sparkles}
 title="Plan Information"
 description="Product details & location for AI estimates and market competition"
 expanded={showPlanInfo}
 onToggle={() => setShowPlanInfo(!showPlanInfo)}
 testId="section-header-plan"
 />
 {showPlanInfo && (
 <CardContent className="space-y-4 pt-5">
 <div className="space-y-2">
 <Label className="text-sm font-semibold">Plan/Product Name *</Label>
 <Input
 value={formData.plan_name}
 onChange={(e) => setFormData(prev => ({ ...prev, plan_name: e.target.value }))}
 placeholder="Freeze-Dried Strawberries"
 />
 </div>
 <div className="space-y-2">
 <Label className="text-sm font-semibold">Product Description <span className="text-red-500">*</span></Label>
 <Input
 value={formData.product_description}
 onChange={(e) => setFormData(prev => ({ ...prev, product_description: e.target.value }))}
 placeholder="e.g., Freeze-dried strawberries, beef stew, mango slices"
 />
 <p className="text-xs text-muted-foreground">💡 Used for AI estimates & market competition analysis</p>
 </div>
 <div className="space-y-2">
 <Label className="text-sm font-semibold">Location (City, State/Province) <span className="text-red-500">*</span></Label>
 <Input
 value={formData.location}
 onChange={(e) => setFormData(prev => ({ ...prev, location: e.target.value }))}
 placeholder={`${user?.city || ''}, ${user?.state || ''}, ${user?.country || 'Your Location'}`}
 />
 <p className="text-xs text-muted-foreground">🌍 Region-specific AI estimates & market competition analysis</p>
 </div>
 
 {/* Tax rates removed - now in separate TaxRates component */}
 </CardContent>
 )}
 </Card>
 );
};

export default PlanInformation;
